<div class="preview-list">
  <app-item-card
    *ngFor="let item of items; index as i"
    [item]="item"
    [shadowColor]="getShadowColor(i)"
  ></app-item-card>
</div>
